import { styled } from "@mui/material";
import { Box } from "@mui/system";
import { DataGrid, DataGridRow } from "@pmag/ui-components";

export const UsageListDataGrid = styled(DataGrid)(() => ({
    "& .MuiDataGrid-columnHeader[data-field='articleName'] > .MuiDataGrid-columnSeparator > div, & .MuiDataGrid-columnHeader[data-field='componentGroupTemplateId'] > .MuiDataGrid-columnSeparator > div":
        {
            visibility: "hidden",
        },
    "& .MuiDataGrid-main": {
        overflow: "scroll",
    },
}));

export const StyledDataGridRow = styled(DataGridRow)(() => ({
    cursor: "pointer",
}));

export const ArrowLinkWrapper = styled(Box)(() => ({
    display: "flex",
    marginLeft: "-10px",
}));
